import { Component, OnInit, Input } from '@angular/core';

/** 
* This component can transclude up to three separate ng-contents:
1. A tooltip (pass using <div tooltip>...</div>)
2. A toggle that sits next to the label (pass using <div class=".toggle-container">...</div>)
3. Everything else will be wrapped within a div with a fieldSize class  
* For paired inputs, set isPaired to true and add 'field--paired-container' to each input, 
* and separate with a div with class 'divider'  
* See also: form.overrides
*/
@Component({
    selector: 'wizard-labeled-field',
    templateUrl: './labeled-field.component.html',
    styleUrls: ['./labeled-field.component.scss']
})
export class LabeledFieldComponent implements OnInit {
    // should always pass these:
    @Input() label = 'Missing label';
    @Input() size: 'tiny' | 'small' | 'medium' | 'big' | 'full';

    // optional:
    @Input() shouldDisplayContentFirst = false; //Displays actual content first if set with isInline input
    @Input() shouldHideTooltip = false;
    @Input() isSecondaryLabel = false; // styles label bluegrey and lighter font weight
    @Input() isInline = false; // input should appear next to the label and tooltip instead of below
    @Input() isPaired = false; // when two fields are used side-by-side
    @Input() alwaysShowHeader = false; // header is hidden on mobile; use this to override

    constructor() {}

    ngOnInit() {}
}
